import { render, staticRenderFns } from "./SpecialNeedsStudents.vue?vue&type=template&id=6191e0db&"
import script from "./SpecialNeedsStudents.vue?vue&type=script&lang=js&"
export * from "./SpecialNeedsStudents.vue?vue&type=script&lang=js&"
import style0 from "./SpecialNeedsStudents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports